import { render } from "./LdapConfiguration.vue?vue&type=template&id=64d983f6&scoped=true"
import script from "./LdapConfiguration.vue?vue&type=script&lang=js"
export * from "./LdapConfiguration.vue?vue&type=script&lang=js"

import "./ldap-configuration.scss?vue&type=style&index=0&id=64d983f6&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\shame\\.codex\\.chatgpt-projects\\g-p-6a9e6467fc748191a03e695eb5ba59d5\\build-work\\hr-dependent-frontend\\src\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64d983f6"]])

export default __exports__